import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { getAuthToken } from '../utils/storage';
import { extractApiError } from '../utils/apiError';

const auditLogsAPI = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  headers: { 'Content-Type': 'application/json' },
});

auditLogsAPI.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

auditLogsAPI.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('access_token');
      localStorage.removeItem('user_data');
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('user_data');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  },
);

const auditLogsService = {
  async getOrderAuditLogs(orderId) {
    try {
      const response = await auditLogsAPI.get(`/orders/${orderId}/audit-logs`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: extractApiError(error) };
    }
  },

  async getPurchaseOrderAuditLogs(poId) {
    try {
      const response = await auditLogsAPI.get(`/purchase-orders/${poId}/audit-logs`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: extractApiError(error) };
    }
  },

  async getDeliverySubOrderAuditLogs(subOrderId) {
    try {
      const response = await auditLogsAPI.get(`/delivery-sub-orders/${subOrderId}/audit-logs`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: extractApiError(error) };
    }
  },

  async getInquiryAuditLogs(inquiryId) {
    try {
      const response = await auditLogsAPI.get(`/inquiries/${inquiryId}/audit-logs`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: extractApiError(error) };
    }
  },

  async getPurchaseAdviceAuditLogs(adviceId) {
    try {
      const response = await auditLogsAPI.get(`/purchase-advices/${adviceId}/audit-logs`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: extractApiError(error) };
    }
  },

  async getOrderTimeline(orderId) {
    try {
      const response = await auditLogsAPI.get(`/orders/${orderId}/timeline`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: extractApiError(error) };
    }
  },

  async getPurchaseOrderTimeline(poId) {
    try {
      const response = await auditLogsAPI.get(`/purchase-orders/${poId}/timeline`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: extractApiError(error) };
    }
  },
};

export default auditLogsService;
